import {createContext} from 'react';

// Primitive context values stay stable when the comparison page refreshes its data.
export const ComparisonHoverContext = createContext(false);
